import * as React from 'react';

import {SaveButton} from '../button/save-button/save-button';
import {ErrorMessage} from '../form/error-message';
import {Body} from '../typography/body';
import {Title} from '../typography/title';

type Props = {
    onSave: () => void;
    error: string | null | undefined;
    isSaving: boolean;
    disabled?: boolean;
    title: string;
    subtitle?: string;
    shouldHideHeader?: boolean;
};

export function SettingsHeader(props: Props) {
    return (
        <div className='flex justify-sb mb-16 align-center'>
            <div className='flex flex-dir-col flex-grow'>
                <Title>{props.shouldHideHeader ? null : props.title}</Title>
                <Body>{props.subtitle}</Body>
            </div>
            <div className='flex align-center'>
                {props.error ? <ErrorMessage>{props.error}</ErrorMessage> : undefined}
                <SaveButton
                    isSaving={props.isSaving}
                    size='big'
                    variant='save'
                    buttonText='Save changes'
                    savingText='Saving changes…'
                    successText='Changes saved!'
                    // @ts-expect-error
                    onClick={props.onSave}
                    disabled={props.disabled}
                    resetOnComplete={true}
                    errorSaving={Boolean(props.error)}
                />
            </div>
        </div>
    );
}
